import React, { useEffect, useState } from 'react';
import { apiRequest } from '../auth/apiClient';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * ENHANCEMENT 5 — "Remove Demo Data" dashboard banner.
 *
 * Polls /api/onboarding/demo-data/status. When the agent has any
 * demo-tagged records present, shows a small banner with a single
 * destructive action "Remove Demo Data" — which calls the matching
 * /remove endpoint and reloads the page so all the now-deleted
 * records disappear from view.
 */
export default function DemoDataBanner() {
  const [present, setPresent] = useState(false);
  const [removing, setRemoving] = useState(false);

  const refresh = async () => {
    try {
      const { ok, data } = await apiRequest('GET',
        `${BACKEND_URL}/api/onboarding/demo-data/status`);
      if (ok) setPresent(!!data.present);
    } catch { /* silent */ }
  };

  useEffect(() => { refresh(); }, []);

  if (!present) return null;

  const remove = async () => {
    if (!window.confirm('Remove all demo records? This cannot be undone.')) return;
    setRemoving(true);
    try {
      const { ok } = await apiRequest('POST',
        `${BACKEND_URL}/api/onboarding/demo-data/remove`);
      if (ok) {
        window.location.reload();
      } else {
        window.alert('Could not remove demo data — please try again.');
      }
    } finally {
      setRemoving(false);
    }
  };

  return (
    <div data-testid="demo-data-banner"
         style={{ background: '#ffffff', border: '1.5px solid #a855f7',
                  borderRadius: 8, padding: '0.65rem 1rem',
                  margin: 0, color: '#6b21a8',
                  display: 'flex', justifyContent: 'space-between',
                  alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
      <div style={{ flex: 1, minWidth: 220 }}>
        <strong>Demo data is loaded.</strong>{' '}
        <span style={{ fontSize: '0.88rem' }}>
          Sample properties, tenants, arrears, compliance, maintenance and
          a lead are visible in your dashboard. Remove it whenever you're
          ready to start with real data.
        </span>
      </div>
      <button
        type="button"
        onClick={remove}
        disabled={removing}
        data-testid="demo-data-remove-btn"
        style={{ background: 'transparent', color: '#7c3aed',
                 border: '1.5px solid #a855f7',
                 padding: '0.45rem 0.95rem', borderRadius: 6,
                 cursor: removing ? 'not-allowed' : 'pointer',
                 fontSize: '0.85rem', fontWeight: 500,
                 whiteSpace: 'nowrap',
                 opacity: removing ? 0.6 : 1 }}>
        {removing ? 'Removing…' : 'Remove Demo Data'}
      </button>
    </div>
  );
}
